import {Translate} from "components/common/Translate/Translate";
import {TutorialParent} from "../TutorialParent";
import JpegCompressorTutorialSvg from "components/common/Resources/JpegCompressorTutorialSVG";

export const JpgResizerTutorial = () => {
    return (
        <TutorialParent>
            <div
                className="flex flex-col md:flex-row w-full gap-x-10 py-24 md:py-36 items-center justify-center content-center bg-[#EEEEEE] dark:bg-gray-800 px-6 md:px-10">
                {/*right*/}
                <div className="flex justify-center content-center items-center">
                    <JpegCompressorTutorialSvg/>
                </div>

                {/*left*/}
                <div className="mt-16 md:mt-0 w-full md:w-auto">
                    {/* header */}
                    <h2 className="font-semibold sub-heading mb-8  md:text-start">
                        <Translate keyName="tutorial-title"/>
                    </h2>
                    {/* tutorial points */}
                    <ol className="flex flex-col gap-3 list-decimal marker:font-semibold  pl-4">
                        <li className="">
                            <span className="pl-1">
                                <Translate keyName="tutorial-1"/>
                            </span>
                        </li>

                        <li className="">
                                <span className="pl-1">
                                    <Translate keyName="tutorial-2"/>
                                </span>
                        </li>
                        <li className="">
                                <span className="pl-1">
                                    {" "}
                                    <Translate keyName="tutorial-3"/>
                                </span>
                        </li>

                    </ol>
                </div>
            </div>
        </TutorialParent>
    );
};
